// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/rest_queued_tasks.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import { TaskStatusType, taskStatusTypeFromJSON, taskStatusTypeToJSON } from "../models/fabric";
import { ImportFabricResponse } from "./api";
import { CloneFabricResponse } from "./rest_fabrics";

export const protobufPackage = "configd";

/** TaskCallbackType defines the type of background task callback. */
export enum TaskCallbackType {
  TASK_CALLBACK_UNSPECIFIED = 0,
  TASK_CALLBACK_CLONE_FABRIC = 1,
  TASK_CALLBACK_IMPORT_FABRIC = 2,
  UNRECOGNIZED = -1,
}

export function taskCallbackTypeFromJSON(object: any): TaskCallbackType {
  switch (object) {
    case 0:
    case "TASK_CALLBACK_UNSPECIFIED":
      return TaskCallbackType.TASK_CALLBACK_UNSPECIFIED;
    case 1:
    case "TASK_CALLBACK_CLONE_FABRIC":
      return TaskCallbackType.TASK_CALLBACK_CLONE_FABRIC;
    case 2:
    case "TASK_CALLBACK_IMPORT_FABRIC":
      return TaskCallbackType.TASK_CALLBACK_IMPORT_FABRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TaskCallbackType.UNRECOGNIZED;
  }
}

export function taskCallbackTypeToJSON(object: TaskCallbackType): string {
  switch (object) {
    case TaskCallbackType.TASK_CALLBACK_UNSPECIFIED:
      return "TASK_CALLBACK_UNSPECIFIED";
    case TaskCallbackType.TASK_CALLBACK_CLONE_FABRIC:
      return "TASK_CALLBACK_CLONE_FABRIC";
    case TaskCallbackType.TASK_CALLBACK_IMPORT_FABRIC:
      return "TASK_CALLBACK_IMPORT_FABRIC";
    case TaskCallbackType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A queued background task. */
export interface QueuedTask {
  /** The task identifier (SHA-256 hex digest of the serialized request). */
  taskId: string;
  /** The current status of the task. */
  status: TaskStatusType;
  /** The type of background task. */
  taskType: TaskCallbackType;
  /** The error message (populated when status is ERROR). */
  errorMessage: string;
  /** When the task was enqueued. */
  createdAt:
    | Date
    | undefined;
  /** When the task finished (success or failure). */
  completedAt:
    | Date
    | undefined;
  /**
   * Typed response payload (populated when status is COMPLETED).
   * Exactly one field is set, determined by task_type.
   */
  cloneFabricResponse: CloneFabricResponse | undefined;
  importFabricResponse: ImportFabricResponse | undefined;
}

/** The request to get all queued tasks for the caller's organization. */
export interface GetQueuedTasksRequest {
  /** The max number of tasks to return per page (default and max: 100). */
  max: number;
  /** Cursor for the next page of results (from a previous response). */
  cursor: string;
  /** Optional status filter. When set, only tasks matching one of the given statuses are returned. */
  status: TaskStatusType[];
}

/** The response containing queued task summaries. */
export interface GetQueuedTasksResponse {
  /** A list of queued task summaries. */
  tasks: QueuedTask[];
  /** Cursor for the next page. Empty when there are no more results. */
  cursor: string;
}

/** The request to get a specific queued task by task_id. */
export interface GetQueuedTaskRequest {
  /** The task identifier (SHA-256 hex digest). */
  taskId: string;
}

function createBaseQueuedTask(): QueuedTask {
  return {
    taskId: "",
    status: 0,
    taskType: 0,
    errorMessage: "",
    createdAt: undefined,
    completedAt: undefined,
    cloneFabricResponse: undefined,
    importFabricResponse: undefined,
  };
}

export const QueuedTask: MessageFns<QueuedTask> = {
  encode(message: QueuedTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== "") {
      writer.uint32(10).string(message.taskId);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.taskType !== 0) {
      writer.uint32(24).int32(message.taskType);
    }
    if (message.errorMessage !== "") {
      writer.uint32(34).string(message.errorMessage);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.completedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.completedAt), writer.uint32(50).fork()).join();
    }
    if (message.cloneFabricResponse !== undefined) {
      CloneFabricResponse.encode(message.cloneFabricResponse, writer.uint32(58).fork()).join();
    }
    if (message.importFabricResponse !== undefined) {
      ImportFabricResponse.encode(message.importFabricResponse, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QueuedTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueuedTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.taskType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.completedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.cloneFabricResponse = CloneFabricResponse.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.importFabricResponse = ImportFabricResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueuedTask {
    return {
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      status: isSet(object.status) ? taskStatusTypeFromJSON(object.status) : 0,
      taskType: isSet(object.taskType) ? taskCallbackTypeFromJSON(object.taskType) : 0,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      completedAt: isSet(object.completedAt) ? fromJsonTimestamp(object.completedAt) : undefined,
      cloneFabricResponse: isSet(object.cloneFabricResponse)
        ? CloneFabricResponse.fromJSON(object.cloneFabricResponse)
        : undefined,
      importFabricResponse: isSet(object.importFabricResponse)
        ? ImportFabricResponse.fromJSON(object.importFabricResponse)
        : undefined,
    };
  },

  toJSON(message: QueuedTask): unknown {
    const obj: any = {};
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.status !== 0) {
      obj.status = taskStatusTypeToJSON(message.status);
    }
    if (message.taskType !== 0) {
      obj.taskType = taskCallbackTypeToJSON(message.taskType);
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.completedAt !== undefined) {
      obj.completedAt = message.completedAt.toISOString();
    }
    if (message.cloneFabricResponse !== undefined) {
      obj.cloneFabricResponse = CloneFabricResponse.toJSON(message.cloneFabricResponse);
    }
    if (message.importFabricResponse !== undefined) {
      obj.importFabricResponse = ImportFabricResponse.toJSON(message.importFabricResponse);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueuedTask>, I>>(base?: I): QueuedTask {
    return QueuedTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueuedTask>, I>>(object: I): QueuedTask {
    const message = createBaseQueuedTask();
    message.taskId = object.taskId ?? "";
    message.status = object.status ?? 0;
    message.taskType = object.taskType ?? 0;
    message.errorMessage = object.errorMessage ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.completedAt = object.completedAt ?? undefined;
    message.cloneFabricResponse = (object.cloneFabricResponse !== undefined && object.cloneFabricResponse !== null)
      ? CloneFabricResponse.fromPartial(object.cloneFabricResponse)
      : undefined;
    message.importFabricResponse = (object.importFabricResponse !== undefined && object.importFabricResponse !== null)
      ? ImportFabricResponse.fromPartial(object.importFabricResponse)
      : undefined;
    return message;
  },
};

function createBaseGetQueuedTasksRequest(): GetQueuedTasksRequest {
  return { max: 0, cursor: "", status: [] };
}

export const GetQueuedTasksRequest: MessageFns<GetQueuedTasksRequest> = {
  encode(message: GetQueuedTasksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.max !== 0) {
      writer.uint32(8).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    writer.uint32(26).fork();
    for (const v of message.status) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetQueuedTasksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQueuedTasksRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.status.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.status.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetQueuedTasksRequest {
    return {
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      status: globalThis.Array.isArray(object?.status) ? object.status.map((e: any) => taskStatusTypeFromJSON(e)) : [],
    };
  },

  toJSON(message: GetQueuedTasksRequest): unknown {
    const obj: any = {};
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.status?.length) {
      obj.status = message.status.map((e) => taskStatusTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetQueuedTasksRequest>, I>>(base?: I): GetQueuedTasksRequest {
    return GetQueuedTasksRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetQueuedTasksRequest>, I>>(object: I): GetQueuedTasksRequest {
    const message = createBaseGetQueuedTasksRequest();
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    message.status = object.status?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetQueuedTasksResponse(): GetQueuedTasksResponse {
  return { tasks: [], cursor: "" };
}

export const GetQueuedTasksResponse: MessageFns<GetQueuedTasksResponse> = {
  encode(message: GetQueuedTasksResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tasks) {
      QueuedTask.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetQueuedTasksResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQueuedTasksResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tasks.push(QueuedTask.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetQueuedTasksResponse {
    return {
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => QueuedTask.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: GetQueuedTasksResponse): unknown {
    const obj: any = {};
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => QueuedTask.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetQueuedTasksResponse>, I>>(base?: I): GetQueuedTasksResponse {
    return GetQueuedTasksResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetQueuedTasksResponse>, I>>(object: I): GetQueuedTasksResponse {
    const message = createBaseGetQueuedTasksResponse();
    message.tasks = object.tasks?.map((e) => QueuedTask.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseGetQueuedTaskRequest(): GetQueuedTaskRequest {
  return { taskId: "" };
}

export const GetQueuedTaskRequest: MessageFns<GetQueuedTaskRequest> = {
  encode(message: GetQueuedTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== "") {
      writer.uint32(10).string(message.taskId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetQueuedTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQueuedTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetQueuedTaskRequest {
    return { taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "" };
  },

  toJSON(message: GetQueuedTaskRequest): unknown {
    const obj: any = {};
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetQueuedTaskRequest>, I>>(base?: I): GetQueuedTaskRequest {
    return GetQueuedTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetQueuedTaskRequest>, I>>(object: I): GetQueuedTaskRequest {
    const message = createBaseGetQueuedTaskRequest();
    message.taskId = object.taskId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
